import { fmt } from "../../utils";

/**
 * StationCard component - displays individual station stock information
 */
export default function StationCard({
  station,
  citernesMap,
  selectedStation,
  onClick,
  produit,
}) {
  const sta = station;
  const stationCiternes = citernesMap[sta.id] || {};
  const stk = Object.values(stationCiternes).reduce(
    (sum, c) => sum + (c.volume || 0),
    0,
  );
  const cap = Object.values(stationCiternes).reduce(
    (sum, c) => sum + (c.capacite || 0),
    0,
  );

  // Debug logging for stock calculation
  console.log(
    `[StationCard] ${sta.id}:`,
    `Stock=${fmt(stk)} m³,`,
    `Capacity=${fmt(cap)} m³,`,
    `Creux=${fmt(cap - stk)} m³,`,
    `Citernes:`,
    stationCiternes,
  );

  const seuil = sta.seuil?.[produit] ?? 0;
  const pct = cap > 0 ? Math.round((stk / cap) * 100) : 0;
  const isLow = stk <= seuil && stk > 0;
  const isEmpty = stk === 0;
  const col =
    isEmpty || isLow
      ? "var(--red)"
      : stk < seuil * 2
        ? "var(--gold)"
        : "var(--green)";
  const cls =
    isEmpty || isLow ? "critical" : stk < seuil * 2 ? "warning" : "ok";

  return (
    <div
      key={sta.id}
      className={`sta-card ${cls}`}
      onClick={onClick}
      style={{
        cursor: "pointer",
        border:
          selectedStation?.id === sta.id
            ? "3px solid var(--blue)"
            : "1px solid var(--border)",
        background:
          selectedStation?.id === sta.id
            ? "var(--bg-elevated)"
            : "var(--bg-card)",
      }}
    >
      <div className="sta-name">{sta.label}</div>
      <div className="sta-code">{produit.toUpperCase()}</div>
      <div className="sta-level" style={{ color: col }}>
        {fmt(stk)}
      </div>
      <div className="sta-unit">m³ en stock</div>
      <div className="prog-wrap">
        <div
          className="prog-fill"
          style={{ width: `${pct}%`, background: col }}
        />
      </div>
      <div className="sta-info">
        Seuil: {seuil} m³ · Capacité: {cap} m³ · {pct}%
      </div>

      {/* Citerne Details */}
      {citernesMap[sta.id] && Object.keys(citernesMap[sta.id]).length > 0 && (
        <div
          style={{
            marginTop: 8,
            paddingTop: 8,
            borderTop: "1px solid var(--border)",
          }}
        >
          <div
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: 9,
              color: "var(--text)",
              marginBottom: 4,
              fontWeight: 600,
            }}
          >
            Creux : {fmt(cap - stk)} m³
          </div>
          <div
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: 8,
              color: "var(--muted)",
              letterSpacing: 1,
              textTransform: "uppercase",
              marginBottom: 4,
            }}
          >
            Citernes
          </div>
          {Object.entries(citernesMap[sta.id]).map(
            ([citerneId, citerneData]) => (
              <div
                key={citerneId}
                style={{
                  fontSize: 10,
                  color: "var(--text)",
                  marginBottom: 2,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>{citerneData.label}</span>
                <span
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontWeight: 600,
                  }}
                >
                  {fmt(citerneData.volume)} / {fmt(citerneData.capacite)} m³
                </span>
              </div>
            ),
          )}
        </div>
      )}

      {/* Status Badge */}
      <div style={{ marginTop: 8 }}>
        {isEmpty ? (
          <span className="badge badge-red">Vide</span>
        ) : isLow ? (
          <span className="badge badge-red">⚠ Seuil</span>
        ) : stk < seuil * 2 ? (
          <span className="badge badge-gold">Attention</span>
        ) : (
          <span className="badge badge-green">Normal</span>
        )}
      </div>
    </div>
  );
}
